import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import pt from './pt.json';
import ar from './ar.json';
import hi from './hi.json';
import zh from './zh.json';

export const translations = {
  en,
  es,
  fr,
  pt,
  ar,
  hi,
  zh
};

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' },
  { code: 'zh', name: 'Chinese', nativeName: '中文', dir: 'ltr' }
];

export const DEFAULT_LANGUAGE = 'en';

// Get browser language
export const getBrowserLanguage = () => {
  const browserLang = navigator.language?.split('-')[0] || 'en';
  const supported = SUPPORTED_LANGUAGES.find(l => l.code === browserLang);
  return supported ? browserLang : DEFAULT_LANGUAGE;
};

// Get nested translation value using dot notation
export const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : null;
  }, obj);
};
